export default __webpack_public_path__ + "static/media/denatl.5b92e569.jpg";